module.exports = __webpack_public_path__ + "static/smoothweb-logo-9476ead418a46b2b3804c9f2b20d7c38.svg";